import React from 'react';

const COLOR_MAP: Record<string, string> = {
  green: '#10B981',
  red: '#EF4444',
  yellow: '#F59E0B',
};

const STATUS_TO_COLOR: Record<string, 'green' | 'red' | 'yellow'> = {
  active: 'green',
  paused: 'yellow',
  stopped: 'red',
  error: 'red',
};

export interface StatusDotProps {
  color?: 'green' | 'red' | 'yellow';
  status?: 'active' | 'paused' | 'stopped' | 'error';
}

export const StatusDot: React.FC<StatusDotProps> = ({ color, status }) => {
  const resolved = color ?? (status ? STATUS_TO_COLOR[status] : 'green');
  const fill = COLOR_MAP[resolved];

  return (
    <>
      <style>{`
        @keyframes statusPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.5); opacity: 0.5; }
        }
      `}</style>
      <span
        style={{
          display: 'inline-block',
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: fill,
          animation: 'statusPulse 2s ease-in-out infinite',
          flexShrink: 0,
        }}
      />
    </>
  );
};
